import React from "react"
import EventAlerts from "../../../Notifications/containers/EventAlerts"

const TopBar = ({ selectedCategory }) =>
  selectedCategory === "event" && <EventAlerts />

export default TopBar
